"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasSegmentationHighlight = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var draw_paint_objects_1 = require("../functions/draw/draw-paint-objects");
var style = { width: '100%', height: '100%' };
exports.CanvasSegmentationHighlight = (0, react_1.memo)(function (_a) {
    var paintStyle = _a.paintStyle, canvasSize = _a.canvasSize, paintObjectCurr = _a.highlightedPaintObject, mode = _a.mode;
    var paintObjectPrev = (0, utils_1.usePrevious)(paintObjectCurr);
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _b[0], canvasRef = _b[1];
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        window.requestAnimationFrame(function () {
            if (paintObjectPrev !== undefined) {
                var top_1 = paintObjectPrev.pixelTop;
                var left = paintObjectPrev.pixelLeft;
                var _a = paintObjectPrev.bitMatrix, width = _a.width, height = _a.height;
                context.clearRect(left, top_1, width, height);
            }
            if (mode !== 'rectbox-editor-add-bbox' &&
                mode !== 'rectbox-editor-resize-bbox' &&
                mode !== 'auto-segmentation-crop') {
                if (paintObjectCurr !== undefined) {
                    var top_2 = paintObjectCurr.pixelTop;
                    var left_1 = paintObjectCurr.pixelLeft;
                    var _b = paintObjectCurr.bitMatrix, width_1 = _b.width, height = _b.height;
                    var pixel = context.createImageData(width_1, height); // 0 filled
                    var pixelAt = function (x, y) {
                        return 4 * (width_1 * (y - top_2) + (x - left_1));
                    };
                    var h = paintObjectCurr.label.hue;
                    var _c = tslib_1.__read(paintStyle.faceColorHighlightedSLA, 3), s = _c[0], l = _c[1], a = _c[2];
                    var rgba = (0, utils_1.hslaToRgba)([h, s, l, a]);
                    (0, draw_paint_objects_1.drawPaintObject)(pixel, paintObjectCurr, rgba, pixelAt);
                    context.putImageData(pixel, left_1, top_2);
                }
            }
        });
    }, [
        context,
        paintStyle.faceColorHighlightedSLA,
        mode,
        paintObjectCurr,
        paintObjectPrev
    ]);
    return (react_1.default.createElement("canvas", { style: style, ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasSegmentationHighlight.displayName = 'CanvasSegmentationHighlight';
